import React, { useEffect, useState } from 'react';

import FormGroup from '../../elements/formElements/FormGroup';
import Select from '../../elements/formElements/Select';

import axios from '../../services/MyAxios';

import CasinoSliderItem from 'Api/Models/CasinoSliderItem';
import SubmitButton from 'crm/elements/formElements/SubmitButton';
import { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';

type Props = Readonly<{
    action: (casinoSliderItem: CasinoSliderItem) => unknown;
    errors: ValidationErrors;
    updatedCasinoSliderItem?: CasinoSliderItem;
}>;

function SliderItemForm({ action, errors, updatedCasinoSliderItem }: Props) {
    const [casinoSliderItem, setCasinoSliderItem] = useState<CasinoSliderItem>(
        new CasinoSliderItem({
            casino_game_category_translation_id: '',
            limit: 32,
        })
    );
    const [categories, setCategories] = useState([]);
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        action(casinoSliderItem);
    };

    const getErrorFor = (field: string): string => errors?.[field]?.[0];

    useEffect(() => {
        if (updatedCasinoSliderItem) {
            setCasinoSliderItem(updatedCasinoSliderItem);
            categories.forEach((category, index) => {
                if (category.id === updatedCasinoSliderItem.casino_game_category_translation_id) {
                    setSelectedCategoryIndex(index);
                }
            });
        }
    }, [updatedCasinoSliderItem]);

    useEffect(() => {
        axios.get('/crea/api/casino/categories').then((response) => {
            setCategories(response.data);
            setCasinoSliderItem((prev) =>
                prev.getNew({
                    casino_game_category_translation_id:
                        response.data.length > 0 ? parseInt(response.data[0].id) : null,
                })
            );
        });
    }, []);

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill" encType="multipart/form-data">
            <Select
                error={getErrorFor('casino_game_category_translation_id')}
                field="casino_game_category_translation_id"
                value={selectedCategoryIndex}
                label="For Category"
                options={categories.map((category) => category.name)}
                handleChange={(e) => {
                    setSelectedCategoryIndex(parseInt(e.target.value));
                    setCasinoSliderItem((prev) =>
                        prev.getNew({
                            casino_game_category_translation_id: categories[e.target.value].id,
                        })
                    );
                }}
                required
            />
            <FormGroup
                type="number"
                field="limit"
                value={casinoSliderItem.limit}
                label="Games limit"
                error={getErrorFor('limit')}
                handleChange={(e) => setCasinoSliderItem((prev) => prev.getNew({ limit: parseInt(e.target.value) }))}
            />
            <SubmitButton label="Save" />
        </form>
    );
}

export default SliderItemForm;
